module.exports = {
  pageTitle: 'Чаты',
  records_for_delete_modal: 'записи',
  multi_delete_records_modal_label: 'Удалить выбранные',
  multi_delete_records_modal_description: 'Будут удалены все выбранные записи',
  record_delete_modal_label: 'Удалить запись',
  change_column_display_modal: {
    modal_label: 'Отображение колонок',
    modal_description: 'Описание',
    choose_cols: 'Выберите отображаемые колонки',
  },
  popup_hints: {
    upload_modal: 'Загрузить записи',
    data_display_set_up: 'Настроить отображение данных',
    download_record: 'Скачать аудиозапись',
    to_record_title: 'Перейти к просмотру записи',
    delete_icon: 'Удалить',
    go_to_audio: 'Перейти к просмотру записи',
  },
  system: {
    calls: 'звонков',
    preset_template_default_name: 'Введите название шаблона',
  },
  popover: {
    download_records: 'Выгрузить выбранные записи',
    delete_selected: 'Удалить выбранные',
    buttonLabel: 'Действия'
  },
  filter: {
    buttons: {
      save_as_template: 'Сохранить как шаблон пресета',
      reset_filter: 'Очистить'
    }
  },
  table: {
    first_column: 'Длительность',
    last_column: 'Действия'
  }
}
